/**
 * Tools Seat Map page for endusers
 * Uses shared SeatMapViewer component
 */
import { createRoute, useSearch, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { toolsRoute } from './index'
import { SeatMapViewer, validateSeatMapSearch } from '@/components/amadeus'

function ToolsSeatMapPage() {
  const navigate = useNavigate()
  const searchParams = useSearch({ from: '/tools/seatmap' })

  return (
    <div className="max-w-6xl mx-auto">
      {/* Back button */}
      <button
        onClick={() => navigate({ to: '/tools' })}
        className="flex items-center gap-2 text-slate-500 hover:text-slate-700 mb-6 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Zurück zur Übersicht
      </button>

      <SeatMapViewer
        searchParams={searchParams}
        activeButtonClass="bg-purple-500"
      />
    </div>
  )
}

export const toolsSeatmapRoute = createRoute({
  getParentRoute: () => toolsRoute,
  path: '/seatmap',
  component: ToolsSeatMapPage,
  validateSearch: validateSeatMapSearch,
})
